import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  TableWrapper,
  StyledTable,
  StyledThead,
  StyledTbody,
  StyledTr,
  StyledTh
} from '../css';
import IotTableRow from './iotTableRow';
import { buildColumnDescriptors, buildGroupMeta } from '../util';

/**
 * Renders a single IoT table from a list of `ioTTableListItem` entries:
 * the `isHeader` entry becomes the header row (titles in authored order) and
 * every other entry becomes a data row. Columns are derived from the header's
 * `headerList` (variable count) and values are placed by `columnKey`, so
 * reordering columns in Contentful does not change correctness.
 */
const IotTable = ({
  tableList,
  interactive,
  selectTermPlaceholder,
  completedProducts,
  onRowComplete,
  unitFloors,
  isRenewal
}) => {
  const list = Array.isArray(tableList) ? tableList : [];
  const headerEntry = list.find(entry =>
    _.get(entry, 'fields.isHeader', false)
  );
  const columns = buildColumnDescriptors(headerEntry);
  const groupMeta = buildGroupMeta(list);
  const savedByKey = _.keyBy(
    Array.isArray(completedProducts) ? completedProducts : [],
    'key'
  );

  const dataEntries = list
    .map((entry, index) => ({ entry, index }))
    .filter(({ entry }) => !_.get(entry, 'fields.isHeader', false));

  return (
    <TableWrapper>
      <StyledTable>
        {headerEntry && (
          <StyledThead>
            <StyledTr>
              {columns.map(column => (
                <StyledTh key={`header-${column.index}`} scope="col">
                  {column.title}
                </StyledTh>
              ))}
            </StyledTr>
          </StyledThead>
        )}
        <StyledTbody>
          {dataEntries.map(({ entry, index }) => {
            const rowKey = _.get(entry, 'sys.id', `row-${index}`);
            return (
              <IotTableRow
                key={rowKey}
                entry={entry}
                columns={columns}
                groupMeta={groupMeta[index]}
                interactive={interactive}
                selectTermPlaceholder={selectTermPlaceholder}
                rowKey={rowKey}
                savedSelection={savedByKey[rowKey]}
                savedSelections={savedByKey}
                onRowComplete={onRowComplete}
                hardwareUnits={_.get(unitFloors, rowKey, null)}
                isRenewal={isRenewal}
              />
            );
          })}
        </StyledTbody>
      </StyledTable>
    </TableWrapper>
  );
};

IotTable.propTypes = {
  tableList: PropTypes.arrayOf(PropTypes.shape({})),
  interactive: PropTypes.bool,
  selectTermPlaceholder: PropTypes.string,
  completedProducts: PropTypes.arrayOf(PropTypes.shape({})),
  onRowComplete: PropTypes.func,
  unitFloors: PropTypes.shape({}),
  isRenewal: PropTypes.bool
};

IotTable.defaultProps = {
  tableList: [],
  interactive: false,
  selectTermPlaceholder: '',
  completedProducts: [],
  onRowComplete: null,
  unitFloors: null,
  isRenewal: false
};

export default IotTable;
